import { render, staticRenderFns } from "./AccessProfilesPage.vue?vue&type=template&id=47abab7a&"
import script from "./AccessProfilesPage.vue?vue&type=script&lang=js&"
export * from "./AccessProfilesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports